import { useQuoteRequestsQuotes } from "#modules/quoteRequests/view/useQuoteRequestsQuotes";
import { Icon } from "#shared/icons/Icon";
import { AnalyticsEvent, useAnalytics } from "#shared/useAnalytics";
import { Anchor } from "#shared/view/components/Anchor";
import { Menu } from "#shared/view/components/Menu";

export const QuotesList = ({ quoteRequestId }: { quoteRequestId: string }) => {
  const { quotes } = useQuoteRequestsQuotes(quoteRequestId);
  const analytics = useAnalytics();

  if (!quotes || quotes.length === 0) {
    return null;
  }

  return (
    <>
      <Menu.Divider />
      <Menu.Label>Devis à télécharger</Menu.Label>
      {quotes.map((quote) => (
        <Menu.Item key={quote.id} leftSection={<Icon name="download" size={14} />}>
          <Anchor
            href={quote.pdfFileUrl}
            style={{ textDecoration: "none" }}
            component="a"
            c="inherit"
            target="_blank"
            rel="noopener noreferrer"
            download
            onClick={() =>
              analytics.capture(AnalyticsEvent.QuotePdfDownloaded, {
                quote_id: quote.id,
                version: quote.version,
                quote_request_id: quoteRequestId,
                area: "header",
              })
            }
          >
            {quote.version}
          </Anchor>
        </Menu.Item>
      ))}
    </>
  );
};
